/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSetting } from '../fn/customer-quick-insights-threshold-setting/add-setting';
import { AddSetting$Params } from '../fn/customer-quick-insights-threshold-setting/add-setting';
import { CustomerQuickInsightsThresholdSetting } from '../models/customer-quick-insights-threshold-setting';
import { deleteSetting } from '../fn/customer-quick-insights-threshold-setting/delete-setting';
import { DeleteSetting$Params } from '../fn/customer-quick-insights-threshold-setting/delete-setting';
import { getList } from '../fn/customer-quick-insights-threshold-setting/get-list';
import { GetList$Params } from '../fn/customer-quick-insights-threshold-setting/get-list';
import { getSetting } from '../fn/customer-quick-insights-threshold-setting/get-setting';
import { GetSetting$Params } from '../fn/customer-quick-insights-threshold-setting/get-setting';
import { getSettingsByTitleRoleId } from '../fn/customer-quick-insights-threshold-setting/get-settings-by-title-role-id';
import { GetSettingsByTitleRoleId$Params } from '../fn/customer-quick-insights-threshold-setting/get-settings-by-title-role-id';
import { updateSetting_2 } from '../fn/customer-quick-insights-threshold-setting/update-setting-2';
import { UpdateSetting_2$Params } from '../fn/customer-quick-insights-threshold-setting/update-setting-2';

@Injectable({ providedIn: 'root' })
export class CustomerQuickInsightsThresholdSettingService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getList()` */
  static readonly GetListPath = '/api/customer/quickInsight/threshold/setting';

  /**
   * Get List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList$Response(params?: GetList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerQuickInsightsThresholdSetting>>> {
    return getList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList(params?: GetList$Params, context?: HttpContext): Observable<Array<CustomerQuickInsightsThresholdSetting>> {
    return this.getList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerQuickInsightsThresholdSetting>>): Array<CustomerQuickInsightsThresholdSetting> => r.body)
    );
  }

  /** Path part for operation `addSetting()` */
  static readonly AddSettingPath = '/api/customer/quickInsight/threshold/setting';

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting$Response(params: AddSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
    return addSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting(params: AddSetting$Params, context?: HttpContext): Observable<CustomerQuickInsightsThresholdSetting> {
    return this.addSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerQuickInsightsThresholdSetting>): CustomerQuickInsightsThresholdSetting => r.body)
    );
  }

  /** Path part for operation `getSettingsByTitleRoleId()` */
  static readonly GetSettingsByTitleRoleIdPath = '/api/customer/quickInsight/threshold/setting/customerId/{customerId}';

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettingsByTitleRoleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId$Response(params: GetSettingsByTitleRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
    return getSettingsByTitleRoleId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettingsByTitleRoleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId(params: GetSettingsByTitleRoleId$Params, context?: HttpContext): Observable<CustomerQuickInsightsThresholdSetting> {
    return this.getSettingsByTitleRoleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerQuickInsightsThresholdSetting>): CustomerQuickInsightsThresholdSetting => r.body)
    );
  }

  /** Path part for operation `getSetting()` */
  static readonly GetSettingPath = '/api/customer/quickInsight/threshold/setting/{settingId}';

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting$Response(params: GetSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
    return getSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting(params: GetSetting$Params, context?: HttpContext): Observable<CustomerQuickInsightsThresholdSetting> {
    return this.getSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerQuickInsightsThresholdSetting>): CustomerQuickInsightsThresholdSetting => r.body)
    );
  }

  /** Path part for operation `updateSetting_2()` */
  static readonly UpdateSetting_2Path = '/api/customer/quickInsight/threshold/setting/{settingId}';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting_2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_2$Response(params: UpdateSetting_2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
    return updateSetting_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting_2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_2(params: UpdateSetting_2$Params, context?: HttpContext): Observable<CustomerQuickInsightsThresholdSetting> {
    return this.updateSetting_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerQuickInsightsThresholdSetting>): CustomerQuickInsightsThresholdSetting => r.body)
    );
  }

  /** Path part for operation `deleteSetting()` */
  static readonly DeleteSettingPath = '/api/customer/quickInsight/threshold/setting/{settingId}';

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting$Response(params: DeleteSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
    return deleteSetting(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting(params: DeleteSetting$Params, context?: HttpContext): Observable<CustomerQuickInsightsThresholdSetting> {
    return this.deleteSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerQuickInsightsThresholdSetting>): CustomerQuickInsightsThresholdSetting => r.body)
    );
  }

}
